"use strict";

exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.number.to-fixed.js");
var _default = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "z-price",
      style: {
        color: _vm.color
      }
    }, [_vm.position === 'left' ? _vm._t("desc", [_c('div', {
      staticClass: "z-price__desc",
      style: {
        color: _vm.descColor
      }
    }, [_vm._v("\n      " + _vm._s(_vm.desc) + "\n    ")])]) : _vm._e(), _vm._t("unit", [_c('div', {
      staticClass: "z-price__unit",
      style: {
        marginLeft: _vm.position === 'left' ? '6px' : '0px'
      }
    }, [_vm._v(_vm._s(_vm.unit))])]), _vm._t("price", [_c('div', {
      staticClass: "z-price__price"
    }, [_vm._v(_vm._s(_vm.realPrice))])]), _vm.position === 'right' ? _vm._t("desc", [_c('div', {
      staticClass: "z-price__desc",
      style: {
        color: _vm.descColor
      }
    }, [_vm._v("\n      " + _vm._s(_vm.desc) + "\n    ")])]) : _vm._e()], 2);
  },
  name: 'z-price',
  props: {
    unit: {
      type: String,
      default: '¥'
    },
    price: {
      type: Number,
      default: 0
    },
    desc: {
      type: String,
      default: '到手价'
    },
    decimals: {
      type: Number,
      default: 0
    },
    color: {
      type: String,
      default: '#111111'
    },
    descColor: {
      type: String,
      default: '#999999'
    },
    position: {
      type: String,
      default: 'right',
      validator: function validator(val) {
        return ['left', 'right'].includes(val);
      }
    },
    useDecimals: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    realPrice: function realPrice() {
      if (!this.useDecimals) {
        return this.price;
      }
      return this.price.toFixed(this.decimals);
    }
  }
};
exports.default = _default;